<template>
  <div
    class="hover:bg-gray-200 padding-y-3 padding-x-4 cursor-pointer"
    :class="{ 'bg-gray-100': item.id === selectedVersion }"
  >
    <div class="text-xs">#{{ count - item.id }}</div>
    <div class="text-sm font-medium">
      {{ formatDateToMinutes(item.updatedAt) }}
    </div>
    <div class="text-sm text-gray-500 mb-2">{{ item.updatedBy }}</div>

    <UITag
      id="pg-email-builder-versions-currentversion"
      type="info"
      v-if="item.id === 0"
    >
      {{ $t('emailCampaign.currentVersion') }}
    </UITag>
  </div>
</template>

<script setup lang="ts">
import { defineComponent } from 'vue'
import { useDateFormat } from '../../composable/filters'
import { UITag } from '@gohighlevel/ghl-ui'
const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  count: {
    type: Number,
    required: true,
  },
  selectedVersion: {
    type: Number,
    required: true,
  },
})
const { formatDateToMinutes } = useDateFormat()
</script>

<style scoped>
.padding-y-3 {
    padding-top: .75rem;
    padding-bottom: .75rem;
}
.padding-x-4 {
    padding-left: 1rem;
    padding-right: 1rem;
}
</style>
